var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8957 15.3437C39.6339 14.5337 38.9155 13.9585 38.0655 13.8819L26.5205 12.8336L21.9552 2.14817C21.6186 1.36506 20.852 0.858154 20.0002 0.858154C19.1484 0.858154 18.3818 1.36506 18.0452 2.15L13.48 12.8336L1.93303 13.8819C1.08462 13.9603 0.368046 14.5337 0.104673 15.3437C-0.158701 16.1537 0.0845308 17.042 0.726332 17.6021L9.45306 25.2554L6.87975 36.5909C6.69145 37.4243 7.01495 38.2859 7.70649 38.7858C8.07821 39.0543 8.51309 39.191 8.95164 39.191C9.32976 39.191 9.70483 39.0891 10.0415 38.8877L20.0002 32.9357L29.9553 38.8877C30.6838 39.3259 31.6021 39.286 32.2921 38.7858C32.9839 38.2843 33.3071 37.4225 33.1188 36.5909L30.5455 25.2554L39.2722 17.6036C39.914 17.042 40.1591 16.1552 39.8957 15.3437Z",
    fill: "#E6358D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkStar);
export default __webpack_public_path__ + "static/media/pink-star.a6c3b4e85f06be731b571553f1c4df00.svg";
export { ForwardRef as ReactComponent };